import axiosInstance from '../../Apis/axiosInterceptor/axiosInstance'

const teamProvider = {
  getList: (resource, params) => {
    const { org } = params.filter
    const url = `v1/orgs/${org}/teams`

    return axiosInstance.get(url).then(({ data }) => {
      return {
        data: data,
        total: data.length,
      }
    })
  },

  getMany: () => {
    return Promise.reject('Provider: team, Method: getMany')
  },
}

export default teamProvider
